export class GenderPayGapTemplateConstants {
}
GenderPayGapTemplateConstants.NamingConflictsParamName = 'namingConflicts';
GenderPayGapTemplateConstants.GenderColumn = 'Gender';
GenderPayGapTemplateConstants.GenderTotalsOutput = 'Gender Totals';
GenderPayGapTemplateConstants.GenderTotalsGenderColumn = GenderPayGapTemplateConstants.GenderColumn;
GenderPayGapTemplateConstants.GenderTotalsCountColumn = 'Count';
GenderPayGapTemplateConstants.MeanPayOutput = 'Mean Pay';
GenderPayGapTemplateConstants.MeanPayGenderColumn = GenderPayGapTemplateConstants.GenderColumn;
GenderPayGapTemplateConstants.MeanPayRateFrequencyColumn = 'PayRateFrequency';
GenderPayGapTemplateConstants.MeanPayRateColumn = 'MeanPayRate';
GenderPayGapTemplateConstants.MeanBonusOutput = 'Mean Bonus';
GenderPayGapTemplateConstants.MeanBonusGenderColumn = GenderPayGapTemplateConstants.GenderColumn;
GenderPayGapTemplateConstants.MeanBonusFrequencyColumn = 'BonusFrequency';
GenderPayGapTemplateConstants.MeanBonusColumn = 'MeanBonus';
GenderPayGapTemplateConstants.MeanPayByPositionOutput = 'Mean Pay By Position';
GenderPayGapTemplateConstants.MeanPayByPositionGenderColumn = GenderPayGapTemplateConstants.GenderColumn;
GenderPayGapTemplateConstants.MeanPayByPositionRateFrequencyColumn = 'PayRateFrequency';
GenderPayGapTemplateConstants.MeanPayByPositionPositionColumn = 'Position';
GenderPayGapTemplateConstants.MeanPayByPositionRateColumn = 'MeanPayRate';
GenderPayGapTemplateConstants.MedianPayOutput = 'Median Pay';
GenderPayGapTemplateConstants.MedianPayGenderColumn = GenderPayGapTemplateConstants.GenderColumn;
GenderPayGapTemplateConstants.MedianPayRateFrequencyColumn = 'PayRateFrequency';
GenderPayGapTemplateConstants.MedianPayRateColumn = 'MedianPayRate';
GenderPayGapTemplateConstants.MedianBonusOutput = 'Median Bonus';
GenderPayGapTemplateConstants.MedianBonusGenderColumn = GenderPayGapTemplateConstants.GenderColumn;
GenderPayGapTemplateConstants.MedianBonusFrequencyColumn = 'BonusFrequency';
GenderPayGapTemplateConstants.MedianBonusColumn = 'Bonus';
GenderPayGapTemplateConstants.BonusCountOutput = 'Bonus Count';
GenderPayGapTemplateConstants.BonusCountGenderColumns = GenderPayGapTemplateConstants.GenderColumn;
GenderPayGapTemplateConstants.BonusCountCountColumn = 'BonusCount';
GenderPayGapTemplateConstants.PayQuartilesOutput = 'Pay Quartiles';
GenderPayGapTemplateConstants.PayQuartilesGenderColumn = GenderPayGapTemplateConstants.GenderColumn;
GenderPayGapTemplateConstants.PayQuartilesQuartileColumn = 'PayQuartile';
GenderPayGapTemplateConstants.PayQuartilesEmployeeCountColumn = 'PositionCount';
GenderPayGapTemplateConstants.PayQuartilesByPositionOutput = 'Pay Quartiles By Position';
GenderPayGapTemplateConstants.PayQuartilesByPositionGenderColumn = GenderPayGapTemplateConstants.GenderColumn;
GenderPayGapTemplateConstants.PayQuartilesByPositionPositionColumn = 'Position';
GenderPayGapTemplateConstants.PayQuartilesByPositionMinimumColumn = 'Minimum';
GenderPayGapTemplateConstants.PayQuartilesByPositionLowerColumn = 'Lower';
GenderPayGapTemplateConstants.PayQuartilesByPositionMedianColumn = 'Median';
GenderPayGapTemplateConstants.PayQuartilesByPositionUpperColumn = 'Upper';
GenderPayGapTemplateConstants.PayQuartilesByPositionMaximumColumn = 'Maximum';
GenderPayGapTemplateConstants.PositionCountOutput = 'Position Count';
GenderPayGapTemplateConstants.PositionCountGenderColumn = GenderPayGapTemplateConstants.GenderColumn;
GenderPayGapTemplateConstants.PositionCountPositionColumn = 'Position';
GenderPayGapTemplateConstants.PositionCountCountColumn = 'Count';
GenderPayGapTemplateConstants.EmployeesDetailOutput = 'Employees';
// Keep IDs
GenderPayGapTemplateConstants.RenameInputColumnsElementID = '9BrcI-2P_-Cqmg';
GenderPayGapTemplateConstants.GenderPayGapDataElementID = 's_99vOYGJakJeA';
GenderPayGapTemplateConstants.GenderFilterElementID = '3DAuj-N2UkKYQA';
GenderPayGapTemplateConstants.GenderValueElementID = 'hchHD-RWosRALw';
GenderPayGapTemplateConstants.ColumnSelectionElementID = 'QWpAxXCiuZDIcA';
GenderPayGapTemplateConstants.AppendPayRateFrequencyElementID = 'Wc05isSVbPwrBA';
GenderPayGapTemplateConstants.AppendBonusRateFrequencyElementID = 'HdxTNl6c2rWXhg';
GenderPayGapTemplateConstants.ReorderOutputColumnsElementID = 'KEWr8zl9bVmzwA';
GenderPayGapTemplateConstants.ReservedColumnNames = [
    GenderPayGapTemplateConstants.GenderColumn,
    GenderPayGapTemplateConstants.GenderTotalsCountColumn,
    GenderPayGapTemplateConstants.MeanPayRateFrequencyColumn,
    GenderPayGapTemplateConstants.MeanPayRateColumn,
    GenderPayGapTemplateConstants.MeanBonusColumn,
    GenderPayGapTemplateConstants.MeanPayByPositionRateFrequencyColumn,
    GenderPayGapTemplateConstants.MeanPayByPositionPositionColumn,
    GenderPayGapTemplateConstants.MeanPayByPositionRateColumn,
    GenderPayGapTemplateConstants.MedianPayRateFrequencyColumn,
    GenderPayGapTemplateConstants.MedianPayRateColumn,
    GenderPayGapTemplateConstants.MedianBonusFrequencyColumn,
    GenderPayGapTemplateConstants.MedianBonusColumn,
    GenderPayGapTemplateConstants.BonusCountCountColumn,
    GenderPayGapTemplateConstants.PayQuartilesQuartileColumn,
    GenderPayGapTemplateConstants.PayQuartilesEmployeeCountColumn,
    GenderPayGapTemplateConstants.PayQuartilesByPositionPositionColumn,
    GenderPayGapTemplateConstants.PayQuartilesByPositionMinimumColumn,
    GenderPayGapTemplateConstants.PayQuartilesByPositionLowerColumn,
    GenderPayGapTemplateConstants.PayQuartilesByPositionMedianColumn,
    GenderPayGapTemplateConstants.PayQuartilesByPositionUpperColumn,
    GenderPayGapTemplateConstants.PayQuartilesByPositionMaximumColumn,
    GenderPayGapTemplateConstants.PositionCountPositionColumn,
    GenderPayGapTemplateConstants.PositionCountCountColumn
];
//# sourceMappingURL=genderPayGapTemplateConstants.js.map